<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card" v-if="value && value._id">
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                {{value.label}}
                                <br>
                                <span class="text-muted small">{{value.code}}</span>
                            </div>
                            <div class="col-auto">
                                <button class="btn btn-white btn-sm mr-2" @click="removeTreatment">
                                    <i class="fe fe-x-circle"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card card-inactive" v-else>
                    <div class="card-body text-muted text-center small">
                        <button
                            class="btn btn-primary mt-4"
                            @click="openModal({id:'TreatmentSelectModal'})"
                        >{{$t('Select work')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <treatment-modal :save-action="saveAction" :technician-id="technicianId" id="TreatmentSelectModal"></treatment-modal>
    </div>
</template>

<script>
    import Money from "@/components/Money.vue";
    import {modalMixins} from '@/mixins/modal.js';
    import TreatmentModal from "./TreatmentModal";

    export default {
        name: "TreatmentSelector",
        props: {value: null, technicianId: null},
        components: {
            Money,
            TreatmentModal
        },
        mixins: [modalMixins],
        data() {
            return {
                treatment: {},
            }
        },
        computed: {},
        created() {
        },
        watch: {},

        methods: {
            saveAction(treatment) {
                this.$emit('input', treatment);
                this.$emit('change', treatment);
            },

            removeTreatment() {
                this.saveAction(null);
            }
        }
    }
</script>

<style scoped>

</style>
